
let registrProtocol = {
    content: '本协议是普拉托网站（www.pallet360.com以下称为“本网站”）的经营者深圳市普拉托有限公司（以下简称为“普拉托”），与用户（下称为“您”），共同缔结的对双方具有约束力的有效契约。请您仔细阅读本注册协议，您点击"同意并继续"按钮后，即视为您接受并同意遵守本协议的约定。',
    children: [
        {
            title: "一、本站服务条款的确认和接纳",
            content: [
                { desc: '1.1、本站的各项电子服务的所有权和运作权归普拉托所有。您同意所有注册协议条款并完成注册程序才能成为本站的正式用户。您确认：本协议条款是处理双方权利义务的依据，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定或约定。' },
                { desc: "1.2、您点击同意本协议的，即视为您确认自己具有享受本站服务、下单购物等相应的权利能力和行为能力，能够独立承担法律责任。" },
                { desc: '1.3、您确认，如果您在18周岁以下，您只能在父母或其他监护人的监护参与下才能使用本站。' },
                { desc: '1.4、普拉托保留在中华人民共和国大陆地区施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。' },
                { desc: '1.5、您使用本站提供的服务时，应同时接受适用于本站特定服务、活动等的准则、条款和协议（以下统称为“其他条款”）；如果以下使用条件与“其他条款”有不一致之处，则以“其他条款”为准。' },
                { desc: '1.6、为表述便利，商品和服务简称为“商品”或“货物”。' }
            ]
        },
        {
            title: "二、本站服务",
            content: [
                { desc: '2.1、普拉托通过互联网依法为您提供互联网信息等服务，您在完全同意本协议及本站相关规定的情况下，方有权使用本站的相关服务。' },
                { desc: '2.2、您必须自行准备如下设备和承担如下开支：' },
                { desc: ' （1）上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置；' },
                { desc: ' （2）上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。' }
            ]
        },
        {
            title: "三、 用户信息收集及保护",
            content: [
                { desc: '3.1、您应自行诚信向本站提供注册资料，您保证提供的注册资料真实、准确、完整、合法有效，您的注册资料如有变动的，应及时更新其注册资料。如果您提供的注册资料不合法、不真实、不准确、不详尽的，您需承担因此引起的相应责任及后果，并且普拉托保留单方终止您使用普拉托各项服务的权利。' },
                { desc: '3.2、您在本站进行注册、浏览、下单购物、评价、参加活动等行为时，涉及您真实姓名/名称、通信地址、联系电话、电子邮箱、订单详情、评价或反馈、投诉内容、cookies等信息的，本站有权从完成交易、提供配送、售后及客户服务、开展活动、完成良好的客户体验等多种角度予以收集，并将对其中涉及个人隐私信息予以严格保密，除非得到您的授权、为履行强行性法律义务（如国家安全机关指令）或法律另有规定、本注册协议或其他条款另有约定外，本站不会向外界披露您的隐私信息。' },
                { desc: '3.3、您注册成功后，将产生用户名和密码等账户信息，您可以根据本站规定更改您的密码。您应谨慎合理的保存、使用您的账户信息。您若发现任何非法使用您的账户或其他存在安全漏洞的情况的，请立即通知本站并向公安机关报案。' },
                { desc: '3.4、您同意，普拉托拥有通过邮件、短信、电话、网站通知或声明等形式，向在本站注册、购物的用户、收货人发送订单信息、促销活动、售后服务、客户服务等告知信息的权利。如您不希望接收上述信息，可退订。' },
                { desc: '3.5、您同意：您选择向本站的商品销售商或服务提供商（以下统称为“销售商”，含普拉托及第三方卖家）提交订单购买商品或服务的，视为您向销售商披露个人相关信息，接受销售商向您提供商品销售、配送、售后服务、客户服务、处理信用卡付款、数据分析、市场营销帮助或其他必要事宜；如前述全部或部分事宜之一涉及由销售商外的第三方履行的，销售商有权将您的信息以必要方式向第三方披露，第三方有权以履行上述事宜为目的联系您。' },
                { desc: '3.6、您不得将在本站注册获得的账号、密码等账户信息提供给他人使用，否则您应承担由此产生的全部责任，并与实际使用人承担连带责任。' },
                { desc: '3.7、您同意，普拉托有权使用您的注册信息、用户名、密码等信息，登录进入您的注册账户，进行证据保全，包括但不限于公证、见证、协助司法机关进行调查取证等。' },
            ]
        },
        {
            title: "四、 用户依法言行义务（本协议依据国家相关法律法规规章制定，您同意严格遵守以下义务）",
            content: [
                { desc: '4.1、不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；' },
                { desc: '4.2、从中国大陆向境外传输资料信息时必须符合中国有关法律法规；' },
                { desc: '4.3、不得利用本站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；' },
                { desc: '4.4、不得干扰本站的正常运转，不得侵入本站及国家计算机信息系统；' },
                { desc: '4.5、不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；' },
                { desc: '4.6、不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；' },
                { desc: '4.7、不得教唆他人从事本条所禁止的行为；' },
                { desc: '4.8、除本注册协议、其他条款或另有其他约定外，您不得利用在本站注册的账户进行经营活动、牟利行为及其他未经本站许可的行为，包括但不限于以下行为：' },
                { desc: '    4.8.1、您账户内的任何普拉托优惠信息（包括但不限于京券、东券、京豆及其他形式优惠或折扣等）由普拉托享有解释权和修改权，您仅享有在普拉托购物时的使用权，严禁转卖普拉托账户、京券、东券、京豆或其他类型的优惠券、普拉托卡、或利用普拉托账户进行其他经营性行为等；' },
                { desc: '    4.8.2、恶意利用技术手段或其他方式，为获取优惠、折扣或其他利益而注册账户、下单等行为，影响其他用户正常消费行为或相关合法权益、影响普拉托正常销售秩序的行为；' },
                { desc: '    4.8.3、发布广告、垃圾邮件；' },
                { desc: '    4.8.4、以再销售或商业使用为目的对本站商品或服务进行购买的（与普拉托另有合同约定的除外）；' },
                { desc: '    4.8.5、商品或服务的供应商、代理商对其所供商品进行回购的行为；' },
                { desc: '    4.8.6、任何对商品目录、说明、价格、数量、其他用户信息或其他内容的下载、转载、收集、衍生利用、复制、出售、转售或其他形式的使用，无论是否通过Robots、Spiders、自动仪器或手工操作；' },
                { desc: '    4.8.7、本站相关规则、政策、或网页活动规则中限制、禁止的行为；' },
                { desc: '    4.8.8、其他影响普拉托对用户账户正常管理秩序的行为。' },
                { desc: '4.9、您不得利用任何非法手段获取其他用户个人信息，不得将其他用户信息用于任何营利或非营利目的，不得泄露其他用户或权利人的个人隐私，否则普拉托有权采取本协议规定的合理措施制止您的上述行为，情节严重的，将提交公安机关进行刑事立案。' },
                { desc: '4.10、您不得发布任何侵犯他人著作权、商标权等知识产权或其他合法权利的内容；如果有其他用户或权利人发现您发布的信息涉嫌知识产权、或其他合法权益争议的，这些用户或权利人有权要求普拉托删除您发布的信息，或者采取其他必要措施予以制止，普拉托将会依法采取这些措施。' },
                { desc: '4.11、您应不时关注并遵守本站不时公布或修改的各类规则规定。本站保有删除站内各类不符合法律政策或不真实的信息内容而无须通知您的权利。' },
                { desc: '4.12、若您未遵守以上规定的，本站有权做出独立判断并采取暂停或关闭您的账号、冻结账号内余额及普拉托卡金额、关闭相应交易订单、停止发货等措施。您须对自己在网上的言论和行为承担法律责任。' },
            ]
        },
        {
            title: "五、 商品信息",
            content: [
                { desc: '5.1、本站上的商品价格、数量、是否有货等商品信息随时都有可能发生变动，本站不作特别通知。由于网站上商品信息的数量极其庞大，虽然本站会尽最大努力保证您所浏览商品信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，本站网页显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解；普拉托欢迎纠错，并会视情况给予纠错者一定的奖励。' },
                { desc: '   5.1.1、本站售后服务政策为本协议的组成部分，普拉托有权以声明、通知或其他形式变更售后服务政策。' }
            ]
        },
        {
            title: "六、 订单",
            content: [
                { desc: '6.1、在您下订单时，请您仔细确认所购商品的名称、价格、数量、型号、规格、尺寸、联系地址、电话、收货人等信息。收货人与您本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。' },
                { desc: '6.2、除法律另有强制性规定外，双方约定如下：本站上销售商展示的商品和价格等信息仅仅是要约邀请，您下单时须填写您希望购买的商品数量、价款及支付方式、收货人、联系方式、收货地址（合同履行地点）、合同履行方式等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向销售商发出的合同要约；销售商收到您的订单信息后，只有在销售商将您在订单中订购的商品从仓库实际直接向您发出时（以商品出库为标志），方视为您与销售商之间就实际直接向您发出的商品建立了合同关系；如果您在一份订单里订购了多种商品并且销售商只给您发出了部分商品时，您与销售商之间仅就实际直接向您发出的商品建立了合同关系；只有在销售商实际直接向您发出了订单中订购的其他商品时，您和销售商之间就订单中该其他已实际直接向您发出的商品才成立合同关系。您可以随时登录您在本站注册的账户，查询您的订单状态。对于电子书、数字音乐、在线手机充值等数字化商品，您下单并支付货款后合同即成立。' },
                { desc: '6.3、尽管销售商做出最大的努力，但商品目录里的一小部分商品可能会有定价错误。如果发现错误定价，将采取下列之一措施，且不视为违约行为：' },
                { desc: "    6.3.1、如果某一商品的正确定价低于销售商的错误定价，销售商将按照较低的定价向您销售交付该商品。" },
                { desc: "    6.3.2、如果某一商品的正确定价高于销售商的错误定价，销售商会通知您，并根据实际情况决定是否取消订单、停止发货、为已付款用户办理退款等。" },
                { desc: "6.4、由于市场变化及各种以合理商业努力难以控制的因素的影响，本站无法保证您提交的订单信息中希望购买的商品都会有货；如您下单所购买的商品，发生缺货，您有权取消订单，销售商亦有权取消订单，并为已付款的用户办理退款。" },

            ]
        },
        {
            title: "七、 配送",
            content: [
                { desc: '7.1、销售商将会把商品（货物）送到您所指定的收货地址，所有在本站上列出的送货时间为参考时间参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点等相关信息估计得出的。' },
                { desc: ' 7.1、销售商将会把商品（货物）送到您所指定的收货地址，所有在本站上列出的送货时间为参考时间参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点等相关信息估计得出的。' },
                { desc: '  （1）您提供的信息错误、地址不详细等原因导致的；' },
                { desc: '  （2）货物送达后无人签收，导致无法配送或延迟配送的；' },
                { desc: '  （3）情势变更因素导致的；' },
                { desc: '  （4）未能在本站所示的送货参考时间内送货的；' },
                { desc: '  （5）因节假日、大型促销活动、店庆、预购或抢购人数众多等原因导致的；' },
                { desc: '  （6）不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。' },
            ]
        },
        {
            title: "八、 所有权及知识产权条款",
            content: [
                { desc: '8.1、您一旦接受本协议，即表明您主动将其在任何时间段在本站发表的任何形式的信息内容（包括但不限于客户评价、客户咨询、各类话题文章等信息内容）的财产性权利等任何可转让的权利，如著作权、财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给普拉托所有，您同意普拉托有权就任何主体侵权而单独提起诉讼。' },
                { desc: '8.2、本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2011年版著作权法确定）及相关法律规定的著作财产权等权利转让书面协议，其效力及于您在小熊U租网站上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。' },
                { desc: '8.3、您同意并已充分了解本协议的条款，承诺不将已发表于本站的信息，以任何形式发布或授权其他主体以任何方式使用（包括但限于在各类网站、媒体上使用）。' },
                { desc: '8.4、普拉托有权不时地对本协议及本站的内容进行修改，并在本站张贴，无须另行通知您。在法律允许的最大限度范围内，普拉托对本协议及本站内容拥有解释权。' },
                { desc: '8.5、除法律另有强制性规定外，未经普拉托明确的特别书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本站的信息内容，否则，普拉托有权追究其法律责任。' },
                { desc: '8.6、本站所刊登的资料信息（包括但不限于文字、图表、商标、logo、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件等），均是普拉托或其内容提供者的财产，受中国和国际相关版权法规、公约等的保护，未经普拉托书面许可，任何第三方无权将上述资料信息复制、出版、发行、公开展示、编码、翻译、传输或散布至任何其他计算机、服务器、网站或其他媒介。本站上所有内容的汇编是普拉托的排他财产，受中国和国际版权法的保护。本站上所有软件都是普拉托或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。您不得鼓励、协助或授权任何其他人复制、修改、反向工程、反向编译或反汇编、拆解或者试图篡改全部或部分软件，或利用软件创设衍生产品。' },
            ]
        },

        {
            title: "九、 责任限制及不承诺担保",
            content: [
                { desc: '9.1、除非另有明确的书面说明,本站及其所包含的或以其他方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务，均是在“按现状”和“按现有”的基础上提供的。' },
                { desc: '9.2、除非另有明确的书面说明,普拉托不对本站的运营及其包含在本站上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。' },
                { desc: '9.3、普拉托不担保本站所包含的或以其他方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从本站发出的电子信件、信息没有病毒或其他有害成分。' },
                { desc: '9.4、如因不可抗力或其他本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，普拉托会合理地尽力协助处理善后事宜。' },
                { desc: '9.5、您应对账户信息及密码承担保密责任，因您未能尽到信息安全和保密责任而致使您的账户发生任何问题的，您应承担全部责任。同时，因网络环境存在众多不可预知因素，因您自身终端网络原因（包括但不限于断网、黑客攻击、病毒等）造成您的普拉托账户或个人信息等被第三方窃取的，普拉托不承担赔偿责任。' },
                { desc: '9.6、您了解并同意，普拉托有权应国家有关机关的要求，向其提供您在普拉托的用户信息和交易记录等必要信息。如您涉嫌侵犯他人合法权益，则普拉托有权在初步判断涉嫌侵权行为可能存在的情况下，向权利人提供您必要的个人信息。' },
            ]
        },
        {
            title: "十、 协议更新及用户关注义务",
            content: [
                { desc: '根据国家法律法规变化及网站运营需要，普拉托有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本站上即生效，并代替原来的协议。您可随时登录查阅最新协议；您有义务不时关注并阅读最新版的协议、其他条款及网站公告。如您不同意更新后的协议，可以且应立即停止接受普拉托网站依据本协议提供的服务；如您继续使用本站提供的服务的，即视为同意更新后的协议。普拉托建议您在使用本站之前阅读本协议及本站的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。' },
            ]
        },
        {
            title: "十一、法律管辖和适用",
            content: [
                { desc: '本协议的订立、执行和解释及争议的解决均适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其他条款继续有效。如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向有管辖权的中华人民共和国大陆地区法院提起诉讼。' },
            ]
        },
        {
            title: "十二、其他",
            content: [
                { desc: '12.1、普拉托网站所有者是指在政府部门依法许可或备案的普拉托网站经营主体。' },
                { desc: '12.2、普拉托尊重您的合法权利，本协议及本站上发布的各类规则、声明、售后服务政策等其他内容，均是为了更好的、更加便利的为您提供服务。本站欢迎您和社会各界提出意见和建议，普拉托将虚心接受并适时修改本协议及本站上的各类规则。' }
            ]
        },
    ]

}

// 隐私保护
let privacyPledgeList = {
    topContent: '本隐私政策与您所使用的普拉托服务以及该服务所包括的各种业务功能（以下统称“我们的服务”）息息相关，希望您在使用我们的服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。',
    topDesc: '如对本隐私政策或相关事宜有任何问题，或对本政策内容有任何疑问、意见或建议，您可通过本政策最下方【如何联系我们】约定的联系方式与我们联系。',
    children: [
        {
            title: '一、我们如何收集和使用您的个人信息',
            content: [
                { desc: '个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的个人信息包括：基本信息（包括个人姓名、经营地址、个人手机号码）；个人身份信息（包括身份证号码）；面部特征；网络身份标识信息（包括系统账号及与其有关的密码、口令、口令保护答案）；个人财产信息（银行账户信息、交易和消费记录、以及余额、积分优惠券虚拟财产信息）；个人上网记录（包括网站浏览记录、软件使用记录、点击记录）；个人位置信息（包括精准定位信息）；' },
                { desc: '个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的个人信息，本隐私政策中涉及的个人敏感信息包括：您的财产信息（包括银行账户信息、交易记录及积分优惠券等虚拟财产信息）；面部识别特征；个人身份信息（包括身份证号码）；网络身份识别信息（包括账户名及与前述有关的密码与密码保护问题和答案）；其他信息（包括个人手机号码、网页浏览记录、精准定位信息）。' },
                { desc: '我们仅会出于以下目的，收集和使用您的个人信息：' },
                { desc: '（一）您授权我们收集和使用您个人信息的情形' },
                { desc: '我们的服务包括一些核心功能，这些功能包含了实现易点租提供设备租赁/买卖服务及/或免押金服务所必须的功能、改进我们的服务所必须的功能及保障交易安全所必须的功能。我们可能会收集、保存和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的服务。这些功能包括： ' },
                { desc: '1、实现易点租提供设备租赁/买卖服务所必须的功能 ' },
                { desc: '（1）用户注册 ' },
                { desc: '您首先需要注册一个普拉托账户成为普拉托用户。当您注册时，您需要至少向我们提供您准备使用的普拉托账户名及与其有关的密码、您本人的手机号码，面部识别特征，身份信息（个人用户需提供身份证号码，企业用户需提供营业执照以及法定代表人身份证号码），经营地址信息（用作收货地址/退货地址），我们将通过发送短信验证码来验证您的身份是否有效，以及通过我们或第三方合作机构对您进行实名认证注册。其中，您可能需要打开您设备的摄像头（相机）权限，便于我们进行面部识别特征的捕捉。' },
                { desc: '（2）产品信息展示和搜索' },
                { desc: '您可以通过搜索来精准地找到您所需要的产品或服务。我们会保留您的搜索内容以方便您重复输入或为您展示与您搜索内容相关联的产品。请您注意，您的搜索关键词信息无法单独识别您的身份，不属于您的个人信息，我们有权以任何的目的对其进行使用；只有当您的搜索关键词信息与您的其他信息相互结合使用并可以识别您的身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本隐私政策对其进行处理与保护。' },
                { desc: '（3）交易' },
                { desc: '当您准备对拟交易的设备进行租赁/购买时，普拉托系统会根据您的指令生成您租赁或购买该产品的订单。租赁/购买时您需要至少填写您的收货地址以及联系人、联系人手机号码；同时该订单中会载明订单号、您拟租赁/购买的产品信息、价格等信息。' },
                { desc: '上述所有信息构成您的“订单信息”，我们将使用您的订单信息来进行您的身份核验、确定交易、支付结算、为您查询订单以及提供客服咨询与后续服务；我们还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。' },
                { desc: '（4）交付产品或服务功能  ' },
                { desc: '为完成您的订单配送，您知晓并同意：普拉托及/或普拉托合作的第三方配送/快递公司会在上述环节内使用您的订单信息以保证您的产品能够安全送达。' },
                { desc: '（5）客服功能' },
                { desc: '我们的客服功能会使用您的账号信息和订单信息。' },
                { desc: '为保证您的账号安全，我们的客服会使用您的账号信息与您核验您的身份。当您需要我们提供与您订单信息相关的客服服务时，我们将会查询您的订单信息。您有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息，如当您要求我们变更收件地址、联系人或联系电话、因开具发票而需要您提供开票信息。' },
                { desc: '2、改进我们的服务所必须的功能' },
                { desc: '我们可能会收集您的订单信息、浏览信息进行数据分析以形成用户画像，用来将您感兴趣的产品或服务信息展示给您；或在您搜索时向您展示您可能希望找到的产品。我们还可能为了提供服务及改进服质量的合理需要而获得您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，第三方合作机构提供的信息对比结果以及您与我们的关联方、我们合作伙伴之间互动时我们获得的相关信息。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、个性化内容和建议。' },
                { desc: '3、保障交易安全及履约管理所必须的功能' },
                { desc: '为保障交易安全及对您可能出现的违约行为进行及时补救，根据交易方式不同，我们可能需要将您的身份信息、银行账户信息、相关的个人敏感信息通过我们或我们合作的第三方机构完成实名认证或者信用认证。如您拒绝提供上述信息或拒绝授权，可能无法完成交易。正常销售秩序的行为；' },
                { desc: '另外，为提高您使用我们的服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护账户安全，我们可能会通过了解您的浏览信息、订单信息手段来判断您的账号风险，并可能会记录一些我们认为有风险的链接。' },
                { desc: '注意，请您向我们提供真实的、准确的个人信息。您在向我们提供上述信息时，可能含有他人的个人信息，您确认已得他人合法、明确的授权。', bold: true },
                { desc: '（一）您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意： ' },
                { desc: '1、与国家安全、国防安全有关的；', topDistance: true },
                { desc: '2、与公共安全、公共卫生、重大公共利益有关的；', topDistance: true },
                { desc: '3、与犯罪侦查、起诉、审判和判决执行等有关的；', topDistance: true },
                { desc: '4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；', topDistance: true },
                { desc: '5、所收集的个人信息是个人信息主体自行向社会公众公开的；', topDistance: true },
                { desc: '6、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；', topDistance: true },
                { desc: '7、根据您的要求签订合同所必需的；', topDistance: true },
                { desc: '8、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；', topDistance: true },
                { desc: '9、为合法的新闻报道所必需的；', topDistance: true },
                { desc: '10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；' },
                { desc: '11、法律法规规定的其他情形。 ', topDistance: true },
                { desc: '（二）我们从第三方获得您个人信息的情形' },
                { desc: '我们可能从第三方获取您授权共享的账户信息（头像、昵称），并在您同意本隐私政策后将您的第三方账户与您的普拉托账户绑定，使您可以通过第三方账户直接登录并使用我们的服务。' },
                { desc: '这些第三方可能有自己的隐私政策，解释其如何使用和分享您的个人信息。在使用这些第三方网络之前，您应当仔细阅读其隐私政策，确保您同意其收集和分享您个人信息的方式。' },
                { desc: '我们使用上述个人信息的方式主要包括：完善您的注册信息，向您提供我们的产品或服务，商品展示、个性化推荐或发送营销信息，内部审计、履约能力评估、数据分析和研究，以及符合本隐私政策的其他方式。' },
                { desc: '（三）您个人信息使用的规则' },
                { desc: '1、我们会根据本隐私政策的约定并为实现我们的服务功能对所收集的个人信息进行使用。' },
                { desc: '2、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。' },
                { desc: '3、请您注意，您在使用我们的服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除您的个人信息，但该删除不会影响此前基于您的授权所进行的个人信息的处理。 ' },
                { desc: '4、我们会对我们的服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。 ' },
                { desc: '5、当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。 ' },
                { desc: '6、当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过您主动做出勾选的形式事先征求您的同意。' },
                { desc: '（四）重要提示' },
                { desc: '如所有的企业都可能面临的问题一样，考虑到信息技术、网络空间本身的特点，在某些特殊情况下（例如黑客攻击、电信故障等），尽管我们采取了法律、法规等规定的必要的措施，但仍然存在个人信息泄露的风险。除非本隐私政策有其他规定，为了保护您的人身或财产安全，我们特别提示您不要通过公共网络，向我们或任何以我们名义为您提供服务的第三方，提供您的财产状况、健康生理、账户密码或验证码、通信内容等涉及您人身或财产安全的敏感信息。' },
            ]
        },
        {
            title: '二、我们如何共享、转让、公开披露您的个人信息',
            content: [
                { desc: '（一）共享' },
                { desc: '1、我们不会与本公司以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：' },
                { desc: '（1）事先获得您明确的同意或授权；', topDistance: true },
                { desc: '（2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；', topDistance: true },
                { desc: '（3）在法律法规允许的范围内，为维护易点租、易点租的关联方或合作伙伴、您或其他易点租用户或社会公众利益、财产或安   全免遭损害而有必要提供；', topDistance: true },
                { desc: '（4） 只有共享您的信息，才能实现我们的服务的核心功能或提供您需要的服务；', topDistance: true },
                { desc: '（5）应您需求为您处理您与他人的纠纷或争议；', topDistance: true },
                { desc: '（6）符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；', topDistance: true },
                { desc: '（7）基于学术研究而使用；', topDistance: true },
                { desc: '（8）基于符合法律法规的社会公共利益而使用。', topDistance: true },
                { desc: '2、我们可能会将您的个人信息与我们的关联方共享。但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。' },
                { desc: '3、我们可能会向合作伙伴这样的第三方共享您的个人信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。我们的合作伙伴包括以下类型： ' },
                { desc: '（1）产品或技术服务的供应商。我们可能会将您的如姓名、个人手机号码、经营地址等个人信息共享给支持我们功能的第三方。这些支持包括为我们提供物流配送服务、提供信息对比服务、提供支付服务、数据处理等。我们共享这些信息的目的是可以实现我们产品与/或服务的核心交易功能，比如我们必须与物流服务提供商共享您的订单信息才能安排收件；或者我们需要将您的订单号和订单金额与第三方支付机构共享以实现其确认您的付款指令并完成付款等。' },
                { desc: '（2）第三方认证及信用服务提供商。我们必须将您的如姓名、个人手机号码、身份证号码、面部识别特征等个人信息及与交易有关的必要信息与第三方认证及信用服务提供商共享来对您进行实名核验及信息真实性一致性核验，并可能评估您的信用。' },
                { desc: '4、对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。' },
                { desc: '5、为了遵守法律、执行或适用我们的使用条件和其他协议，或者为了保护易点租、您或其他普拉托客户的权利及其财产或安全，比如为防止欺诈等违法活动和减少信用风险，而与其他公司和组织交换信息。不过,这并不包括违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。' },
                { desc: '（二）转让' },
                { desc: '我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外： ' },
                { desc: '1、事先获得您明确的同意或授权； ' },
                { desc: '2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供； ', topDistance: true },
                { desc: '3、符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；', topDistance: true },
                { desc: '4、在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意', topDistance: true },
                { desc: '（三）公开披露' },
                { desc: '我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息： ' },
                { desc: '1、根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息； ' },
                { desc: '2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。', topDistance: true },
            ]
        },
        {
            title: '三、您如何管理您的个人信息',
            content: [
                { desc: '普拉托非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：' },
                { desc: '1、访问和更正您的个人信息' },
                { desc: '除法律法规规定外，您有权随时通过我们的网站或者应用程序访问和更正您的个人信息，包括您的账户信息、地址信息等。',topDistance: true  },
                { desc: '2、删除您的个人信息 ' },
                { desc: '您在我们的服务页面中可以直接清除或删除的信息，包括搜索记录等；',topDistance: true },
                { desc: '在以下情形中，您可以向我们提出删除个人信息的请求：',topDistance: true },
                {desc:'（1）如果我们处理个人信息的行为违反法律法规；',topDistance: true},
                {desc:'（2）如果我们收集、使用您的个人信息，却未征得您的同意；',topDistance: true},
                {desc:'（3）如果我们处理个人信息的行为违反了与您的约定；',topDistance: true},
                {desc:'（4）如果您注销了普拉托账户；',topDistance: true},
                {desc:'（5）如果我们终止服务及运营。',topDistance: true},
                {desc:'当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。',topDistance: true},
                {desc:'3、改变您授权同意的范围或撤回您的授权 '},
                {desc:'您可以通过删除信息、通过您的设备关闭设备功能等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。',topDistance: true},
                {desc:'请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。'},
                {desc:'在以下情形中，按照法律法规要求，我们将无法响应您的请求：'},
                {desc:'（1）与国家安全、国防安全有关的；',topDistance: true},
                {desc:'（2）与公共安全、公共卫生、重大公共利益有关的；',topDistance: true},
                {desc:'（3）与犯罪侦查、起诉和审判等有关的；',topDistance: true},
                {desc:'（4）有充分证据表明您存在主观恶意或滥用权利的；',topDistance: true},
                {desc:'（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。',topDistance: true},
            ]
        }
    ]

}
export { registrProtocol, privacyPledgeList }